import React from 'react'
import HeaderBtn from './HeaderBtn'
import SocialLinks from './SocialLinks'

const techStack = [
  'Node.js', 'JavaScript', 'TypeScript', 'Express', 'MongoDB',
  'MySQL', 'Redis', 'Docker', 'AWS', 'Microservices',
  'REST APIs', 'Stripe', 'Socket.io', 'React', 'Angular'
]

const stats = [
  { value: '3.6+', label: 'Years Experience' },
  { value: '15+',  label: 'Integrations Built' },
  { value: '10+',  label: 'Microservices Shipped' },
]

const Header = () => {
  return (
    <header className='header__container'>
      <div className='container header__inner'>
        <span className='header__badge'>
          <span className='header__badge-dot'></span>
          Available for opportunities
        </span>
        <h5>Hello, I'm</h5>
        <h1>Mohammed Adhil Ashraf</h1>
        <h5 className='header__role'>
          Backend / Node.js Developer <span className='text-primary'>with 3.6+ Years</span> of experience
        </h5>
        <p className='header__tagline'>
          Building scalable Node.js services, microservices and integrations — Stripe, AWS, Docker, Redis &amp; more.
        </p>
        <HeaderBtn />
        <SocialLinks />

        <ul className='header__stats' aria-label='Career highlights'>
          {stats.map((s, i) => (
            <li key={i} className='header__stat'>
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </li>
          ))}
        </ul>

        <ul className='header__chips' aria-label='Tech stack'>
          {techStack.map(t => (
            <li key={t} className='header__chip'>{t}</li>
          ))}
        </ul>

        <a href="/#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header
